module.exports = _.isNull;